module.exports = __webpack_public_path__ + "img/italy-genitourinary-diseases-male.bc702531.png";